import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Link from '../../links/Link/Link';
import Button from '../../buttons/Button/Button';

/**
 * A component for displaying the global site search
 */
function SiteSearch({ logoHref, source, languageHref, searchFormAction }) {
  const { t } = useTranslation();

  return (
    <div className="wg-header">
      <div className="wg-header__content">
        <Link href={logoHref} className="content__wg-link" title={t('styleguide:wgheader_logo_alt')}>
          <img src={source} alt={t('styleguide:wgheader_logo_alt')} />
        </Link>
        <Link href={languageHref} className="button button--style-dark button--small content__lang-link">
          {t('styleguide:wgheader_language')}
        </Link>
        <form className="content__search-form" action={searchFormAction}>
          <div className="form__group js-form-group form__text">
            <label className="group__label" htmlFor="keys">
              {t('styleguide:wgheader_search_label')}
            </label>
            <div className="group__element group__element--has-prefix-suffix">
              <input type="text" id="keys" name="keys" aria-label={t('styleguide:wgheader_search_aria')} />
              <div className="group__suffix">
                <Button
                  type={'submit'}
                  className="button--icon icon--search icon--text-hidden"
                  ariaLabel={t('styleguide:wgheader_search_button_text')}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

SiteSearch.propTypes = {
  /**
   * The logo link
   */
  logoHref: PropTypes.string,
  /**
   * The location of the logo image
   */
  source: PropTypes.string,
  /**
   * The destination of the language link
   */
  languageHref: PropTypes.string,
  /**
   * The action destination of the search form
   */
  searchFormAction: PropTypes.string
};

export default SiteSearch;
